import * as i0 from '@angular/core';
import { InjectionToken, Component, Inject, HostListener, NgModule, Injectable } from '@angular/core';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@ngx-translate/core';
import { LibI18nModule } from '@stephaneeybert/lib-i18n';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';

class ToastData {
    type;
    text;
    template;
    templateContext;
}
const defaultToastConfig = {
    position: {
        top: 20,
        right: 20,
    },
    animation: {
        fadeOut: 2500,
        fadeIn: 300,
    },
};
const TOAST_CONFIG_TOKEN = new InjectionToken('toast-config');

const toastAnimations = {
    fadeToast: trigger('fadeAnimation', [
        state('default', style({ opacity: 1 })),
        transition('void => *', [style({ opacity: 0 }), animate('{{ fadeIn }}ms')]),
        transition('default => closing', animate('{{ fadeOut }}ms', style({ opacity: 0 }))),
    ]),
};

class ToastRef {
    overlay;
    constructor(overlay) {
        this.overlay = overlay;
    }
    close() {
        this.overlay.dispose();
    }
    isVisible() {
        return this.overlay && this.overlay.overlayElement;
    }
    getPosition() {
        return this.overlay.overlayElement.getBoundingClientRect();
    }
}

const _c0 = (a0, a1) => ({ fadeIn: a0, fadeOut: a1 });
const _c1 = (a0, a1) => ({ value: a0, params: a1 });
class ToastComponent {
    translateService;
    data;
    ref;
    toastConfig;
    animationState = 'default';
    intervalId;
    constructor(translateService, data, ref, toastConfig) {
        this.translateService = translateService;
        this.data = data;
        this.ref = ref;
        this.toastConfig = toastConfig;
    }
    ngOnInit() {
        const message = this.translateService.instant('soundtracks.message.maxNbReached');
        console.log(message);
        this.intervalId = setTimeout(() => this.animationState = 'closing', 5000);
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearTimeout(this.intervalId);
        }
    }
    close() {
        this.ref.close();
    }
    onFadeFinished(event) {
        const { toState } = event;
        const isFadeOut = toState === 'closing';
        const itFinished = this.animationState === 'closing';
        if (isFadeOut && itFinished) {
            this.close();
        }
    }
    static ɵfac = function ToastComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToastComponent)(i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(ToastData), i0.ɵɵdirectiveInject(ToastRef), i0.ɵɵdirectiveInject(TOAST_CONFIG_TOKEN)); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToastComponent, selectors: [["app-toast"]], hostBindings: function ToastComponent_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("beforeunload", function ToastComponent_beforeunload_HostBindingHandler() { return ctx.ngOnDestroy(); }, false, i0.ɵɵresolveWindow);
        } }, decls: 6, vars: 11, consts: [[1, "toast"], [3, "click"]], template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("@fadeAnimation.done", function ToastComponent_Template_div_animation_fadeAnimation_done_0_listener($event) { return ctx.onFadeFinished($event); });
            i0.ɵɵelementStart(1, "div");
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 1);
            i0.ɵɵlistener("click", function ToastComponent_Template_div_click_3_listener() { return ctx.close(); });
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵproperty("@fadeAnimation", i0.ɵɵpureFunction2(8, _c1, ctx.animationState, i0.ɵɵpureFunction2(5, _c0, ctx.toastConfig.animation.fadeIn, ctx.toastConfig.animation.fadeOut)));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.data.text);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "toast.close"));
        } }, dependencies: [i1.TranslatePipe], styles: [".toast[_ngcontent-%COMP%]{position:relative;display:flex;justify-content:space-around;margin-bottom:20px;padding:10px 15px 10px 48px;width:290px;background:#fff;border-width:1px;border-style:solid;border-color:#dddddd #d6d6d6 #cfcfcf;box-shadow:0 2px 4px #0000001c}"], data: { animation: [toastAnimations.fadeToast] } });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{ selector: 'app-toast', animations: [toastAnimations.fadeToast], template: "<div class=\"toast\" [@fadeAnimation]=\"{value: animationState, params:\n        { fadeIn: toastConfig.animation.fadeIn, fadeOut: toastConfig.animation.fadeOut }}\"\n  (@fadeAnimation.done)=\"onFadeFinished($event)\">\n  <div>{{ data.text }}</div>\n  <div (click)=\"close()\">{{ 'toast.close' | translate }}</div>\n</div>", styles: [".toast{position:relative;display:flex;justify-content:space-around;margin-bottom:20px;padding:10px 15px 10px 48px;width:290px;background:#fff;border-width:1px;border-style:solid;border-color:#dddddd #d6d6d6 #cfcfcf;box-shadow:0 2px 4px #0000001c}\n"] }]
    }], () => [{ type: i1.TranslateService }, { type: ToastData }, { type: ToastRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [TOAST_CONFIG_TOKEN]
            }] }], { ngOnDestroy: [{
            type: HostListener,
            args: ['window:beforeunload']
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ToastComponent, { className: "ToastComponent", filePath: "lib/toast.component.ts", lineNumber: 14 }); })();

class LibToastModule {
    static forRoot(config = defaultToastConfig) {
        return {
            ngModule: LibToastModule,
            providers: [
                {
                    provide: TOAST_CONFIG_TOKEN,
                    useValue: { ...defaultToastConfig, ...config },
                },
            ],
        };
    }
    static ɵfac = function LibToastModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LibToastModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LibToastModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [OverlayModule,
            LibI18nModule, LibI18nModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibToastModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ToastComponent
                ],
                imports: [
                    OverlayModule,
                    LibI18nModule
                ],
                exports: [
                    LibI18nModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibToastModule, { declarations: [ToastComponent], imports: [OverlayModule,
        LibI18nModule], exports: [LibI18nModule] }); })();

class ToastService {
    overlay;
    parentInjector;
    toastConfig;
    lastToast;
    constructor(overlay, parentInjector, toastConfig) {
        this.overlay = overlay;
        this.parentInjector = parentInjector;
        this.toastConfig = toastConfig;
    }
    show(data) {
        const positionStrategy = this.getPositionStrategy();
        const overlayRef = this.overlay.create({ positionStrategy });
        const toastRef = new ToastRef(overlayRef);
        this.lastToast = toastRef;
        const injector = this.getInjector(data, toastRef, this.parentInjector);
        const toastPortal = new ComponentPortal(ToastComponent, null, injector);
        overlayRef.attach(toastPortal);
        return toastRef;
    }
    getPositionStrategy() {
        return this.overlay.position()
            .global()
            .top(this.getPosition())
            .right(this.toastConfig.position.right + 'px');
    }
    getPosition() {
        const lastToastIsVisible = this.lastToast && this.lastToast.isVisible();
        const position = lastToastIsVisible ? this.lastToast.getPosition().bottom : this.toastConfig.position.top;
        return position + 'px';
    }
    getInjector(data, toastRef, parentInjector) {
        const tokens = new WeakMap();
        tokens.set(ToastData, data);
        tokens.set(ToastRef, toastRef);
        return new PortalInjector(parentInjector, tokens);
    }
    static ɵfac = function ToastService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ToastService)(i0.ɵɵinject(i1$1.Overlay), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(TOAST_CONFIG_TOKEN)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToastService, factory: ToastService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1$1.Overlay }, { type: i0.Injector }, { type: undefined, decorators: [{
                type: Inject,
                args: [TOAST_CONFIG_TOKEN]
            }] }], null); })();

/*
 * Public API Surface of lib-toast
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibToastModule, ToastComponent, ToastService };
